import React from 'react';
import ResponsiveWrapper from '../../../../components/ResponsiveWrapper';
import Admin from './index';
import MobileBoardAdmin from './MobileBoardAdmin';

const ResponsiveBoardAdmin = () => {
  return (
    <ResponsiveWrapper
      mobile={<MobileBoardAdmin />}
      desktop={<Admin />}
    />
  );
};

export default ResponsiveBoardAdmin;